import { put } from 'redux-saga/effects';
import importer from 'common/importer';

const { mulesoft } = importer('APIs/auth', null);
const { resetOktaPassword: resetPassword3 } = mulesoft;

const UserActions = importer('Stores/Users/Actions');

export default function* main({ stateToken, password }) {
	try {
		yield put(UserActions.resetPassword3Loading());
		const resetResponse = yield resetPassword3(stateToken, password);
		// Picking up the stateToken from the success state of resetPassword2 call and passing it to this saga for /reset-password call

		if (!resetResponse.data.isError) {
			yield put(UserActions.resetPassword3Success(resetResponse));
		} else {
			yield put(UserActions.resetPassword3Failure(resetResponse));
		}
	} catch (error) {
		yield put(UserActions.resetPassword3Failure(error));
	}
}
